import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const gif = () => {
  return (
    <DotLottieReact
      src="https://lottie.host/0787f1cb-5812-404f-bf98-eef1934afa85/mRY1aoNCvY.lottie"
      loop
      autoplay
      style={{ width: 'auto', height: '600px' }}
    />
  );
};

export default gif;